// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADMINCLUB_MENU = "Adminclub";
export const PROFILE_BLOCKED__HEADER_username = "Pou\u017e\u00edvate\u013eka %(username)s u\u017e nem\u00e1 \u00fa\u010det na kon\u00edku.";
export const PROFILE_BLOCKED__REASON1_kodex = "poru\u0161ovanie %(kodex)s";
export const PROFILE_BLOCKED__REASON2 = "vytv\u00e1ranie viacn\u00e1sobn\u00fdch profilov";
export const PROFILE_BLOCKED__REASON3 = "na z\u00e1klade podozrenia z podvodn\u00fdch aktiv\u00edt";
export const PROFILE_BLOCKED__REASON4 = "na vlastn\u00fa \u017eiados\u0165";
export const PROFILE_BLOCKED__REASON5 = "vkladanie nepovolenej reklamy na str\u00e1nku";
export const PROFILE_BLOCKED__REASONS_ARE = "Naj\u010dastej\u0161ie je to z t\u00fdchto d\u00f4vodov:";
export const PROFILE_username_BLOCKED_BY_USER = "Pou\u017e\u00edvate\u013eka %(username)s u\u017e nem\u00e1 \u00fa\u010det na Modrom kon\u00edku. K tomuto kroku sa rozhodla sama pou\u017e\u00edvate\u013eka.";
export const RULES_KODEX__GENITIVE = "K\u00f3dexu spr\u00e1vania";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
